const state = () => ({
    invoiceTypeList: [
        {
          value: 1,
          label: '普票',
          type: 'primary'
        },
        {
          value: 2,
          label: '专票',
          type: 'success'
        },
        {
          value: 3,
          label: '无票',
          type: 'info'
        },
        {
          value: 4,
          label: '电子普票',
          type: 'primary'
        },
        {
          value: 5,
          label: '电子专票',
          type: 'success'
        },
        {
          value: 6,
          label: '全电普票',
          type: 'primary'
        },
        {
          value: 7,
          label: '全电专票',
          type: 'success'
        }
      ],
})
const getters = {
    invoiceTypeList: state => {
        return state.invoiceTypeList
      },
}
export default {
    namespaced: true,
    state,
    getters,
  }
  


// WEBPACK FOOTER //
// ./src/store/module/finance.js